import React, {Component} from 'react';
import {Link, withRouter} from 'react-router-dom';
import {getFormattedRouteForRecordingViewForEdit, getFormattedRouteForRecordingViewForSharing} from "../utils";
import {onShareRecording} from "../../../recording/utils";

/**
 * A Route query identifier for handling different
 * behaviour if routed to the edit page from the current page.
 */
export const PERSIST_KEY = 'persist';
export const IS_PERSIST_EDIT_MODE_ON = 'true';
export const IS_PERSIST_EDIT_MODE_OFF = 'false';

/**
 * A dropdown menu attached to a recording card that displays additional options for the recording card.
 * @param dropdownOptionID for identifying the current dropdownID
 * @param selectedUnitID of the currently selected unit
 * @param recordingID of the recording card
 * @param recordingData of the recording card
 */
class RecordingOptionsDropdownMenu extends Component {
    render() {
        const recordingRouteEditModeOn = getFormattedRouteForRecordingViewForEdit(
            this.props.selectedUnitID,
            this.props.recordingID,
            {[PERSIST_KEY]:IS_PERSIST_EDIT_MODE_ON}
        );
        const recordingUrl = getFormattedRouteForRecordingViewForSharing(this.props.selectedUnitID, this.props.recordingID);
        return (
            <div className="dropdown-menu dropdown-menu-right" aria-labelledby={this.props.dropdownOptionID}>
                <Link className="dropdown-item" to={recordingRouteEditModeOn} target="_blank"><i className="fas fa-edit"/> Edit</Link>
                    <button
                        type="button"
                        className="btn dropdown-item"
                        onClick={onShareRecording(this.props.recordingData.privacy, recordingUrl, this.props.selectedUnitID, this.props.recordingID)}
                    >
                        <i className="fas fa-share"/> Share
                    </button>
                {
                    (this.props.recordingData.wowzaURL || this.props.recordingData.wowzaURL2) &&
                    (
                        <div>
                            <a
                                className="dropdown-item"
                                href={this.props.recordingData.wowzaURL || this.props.recordingData.wowzaURL2}
                                target="_blank"
                            >
                                <i className="fas fa-cloud-download-alt"/> Download
                            </a>
                        </div>
                    )
                }
            </div>
        );
    }
}

export default withRouter(RecordingOptionsDropdownMenu);



// WEBPACK FOOTER //
// ./src/components/unit/recordings/recordingcard/RecordingOptionsDropdownMenu.jsx